
export default {
  data() {
    return {
      year: this.$store.state.year
    }
  },
  watch: {
    '$store.state.year': function(val) {
      this.year = parseInt(val);
    }
  }
}
